import { cloneDeep } from 'lodash-es';
import makeDisplay from './makeDisplay'

export default function(row, table) {
	return new Promise(resolve => {
		const build = cloneDeep(table);

		let picklists = build.schema.columns.map(col => {
			if (!col.picklistKey) return null;
			let picklist = build.picklists.find(list => list.picklistKey === col.picklistKey);
			return picklist;
		});

		row[1] = row[1].map((_cell, i) => {
			_cell._edited = true
			_cell._display = makeDisplay(_cell, picklists[i]);
			return _cell;
		});

		resolve(row);
	});
}
